"use strict";

exports.__esModule = true;
exports.default = void 0;

var _schema = _interopRequireDefault(require("./schema"));

var _uiSchema = _interopRequireDefault(require("./uiSchema"));

var _preview = _interopRequireDefault(require("../../preview/"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = {
  id: 1,
  schemaType: 'kp',
  name: 'topic',
  schema: _schema.default,
  uiSchema: _uiSchema.default,
  preview: {
    template: _preview.default
  }
};
exports.default = _default;
module.exports = exports.default;